@use "../../styles/breakpoint.module.scss" as *;

.container {
    background-color: var(--off-white);
}

.inner {
    composes: gridContainer from "../../styles/composable/layout.module.css";
}

.content {
    grid-column: 3 / span 8;
    padding-block: var(--spacer-104);

    @media ($below-tablet) {
        grid-column: 2 / span 10;
    }

    @media ($below-mobile) {
        grid-column: span 4;
    }
}

.header {
    font: var(--font-h-34);
    text-align: center;
}

.captionText {
    margin-block: var(--spacer-56);
    text-align: center;

    p {
        font: var(--font-p-18);
    }
}

/* v2026 */

.container2026 {
    background-color: var(--off-white);
}

.inner2026 {
    max-width: 1360px;
    margin-inline: auto;
    padding-inline: var(--labui-container-margin);
    padding-block: var(--spacer-40) var(--spacer-80);

    @media ($below-mobile) {
        padding-block: var(--spacer-24) var(--spacer-56);
    }
}

.backLink {
    display: inline-flex;
    align-items: center;
    gap: var(--spacer-8);
    font: var(--font-eyebrow-12);
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: var(--black);
    text-decoration: none;
}

.backLinkIcon {
    width: 16px;
    height: 16px;
    transform: rotate(180deg) translateY(1px);
}

.textHeader {
    max-width: 896px;
    margin-inline: auto;
    text-align: center;
    display: flex;
    flex-direction: column;
    gap: var(--spacer-16);
    padding-block: var(--spacer-40);

    @media ($below-mobile) {
        padding-block: var(--spacer-24);
    }
}

.header2026 {
    font: var(--font-h-64);
}

.captionText2026 {
    p {
        font: var(--font-p-18);
    }
}

.body2026 {
    max-width: 892px;
    margin-inline: auto;
    font: var(--font-p-16);
}
